import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { PageHeader } from '../components/PageHeader';
import { PageLayout } from '../components/PageLayout';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export function ChangePasswordPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!novaSenha || novaSenha.length < 6) {
      toast.error('A nova senha deve ter no mínimo 6 caracteres');
      return;
    }
    if (novaSenha !== confirmarSenha) {
      toast.error('As senhas não coincidem');
      return;
    }
    if (!user?.id) {
      toast.error('Sessão inválida. Faça login novamente.');
      return;
    }

    setSaving(true);
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`/api/users/${user.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ senha: novaSenha })
      });

      if (response.ok) {
        toast.success('Senha alterada com sucesso!');
        setNovaSenha('');
        setConfirmarSenha('');
        navigate(-1);
      } else {
        const err = await response.json();
        throw new Error(err.message || 'Erro ao alterar senha');
      }
    } catch (error: unknown) {
      toast.error(error instanceof Error ? error.message : 'Erro ao alterar senha');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Header title="Alterar senha" subtitle="Altere a senha da sua conta" compactTopbar />
      <PageLayout>
        <PageHeader
          title="Alterar senha"
          breadcrumbs={[
            { label: 'Home', href: '/' },
            { label: 'Alterar senha' }
          ]}
        />
        <div className="space-y-8 w-full">
          <div className="card-padrao overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
              <h2 className="font-semibold text-gray-800 dark:text-white/90">Nova senha</h2>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
                Defina uma nova senha para acessar sua conta. Use no mínimo 6 caracteres.
              </p>
            </div>
            <form onSubmit={handleSubmit} className="p-6 space-y-6">
              <div>
                <label htmlFor="novaSenha" className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                  Nova senha *
                </label>
                <input
                  id="novaSenha"
                  type="password"
                  value={novaSenha}
                  onChange={(e) => setNovaSenha(e.target.value)}
                  placeholder="Mínimo 6 caracteres"
                  className="input-field w-full text-sm border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                  required
                  minLength={6}
                  autoComplete="new-password"
                />
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  Use letras maiúsculas, minúsculas e números.
                </p>
              </div>
              <div>
                <label htmlFor="confirmarSenha" className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                  Confirmar nova senha *
                </label>
                <input
                  id="confirmarSenha"
                  type="password"
                  value={confirmarSenha}
                  onChange={(e) => setConfirmarSenha(e.target.value)}
                  placeholder="Repita a nova senha"
                  className="input-field w-full text-sm border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                  required
                  minLength={6}
                  autoComplete="new-password"
                />
              </div>
              <div className="pt-4 border-t border-gray-200 dark:border-gray-700 flex flex-wrap items-center justify-end gap-3">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800/50 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                >
                  <i className="fas fa-arrow-left text-base shrink-0" aria-hidden />
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={saving}
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium border border-transparent text-white bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {saving ? (
                    <>
                      <i className="fas fa-spinner fa-spin text-base shrink-0" aria-hidden />
                      Salvando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-check text-base shrink-0" aria-hidden />
                      Salvar nova senha
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </PageLayout>
    </>
  );
}
